(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-barra-compra"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function montar(barra) {
      if (barra.dataset.peListo === '1') return;
      barra.dataset.peListo = '1';

      var boton = barra.querySelector('[data-pe-barra-boton]');
      var etiqueta = barra.querySelector('[data-pe-barra-etiqueta]');
      var precio = barra.querySelector('[data-pe-barra-precio]');

      function botonFicha() {
        return document.querySelector('.product__info-container .product-form__submit');
      }

      function precioFicha() {
        return document.querySelector('.product__info-container [id^="price-"]');
      }

      // El estado sale del botón de la ficha, no se calcula otra vez aquí: si
      // Shopify lo deja apagado por falta de stock, este también.
      //
      // El texto solo se copia cuando está apagado, para que diga lo mismo que
      // arriba —"Agotado", "No disponible"—. Encendido lleva el texto corto de
      // los ajustes: en la barra el ancho es del nombre del producto, y
      // "Agregar al carrito" se lo comía entero.
      function copiar() {
        var origen = botonFicha();
        if (!origen) {
          boton.disabled = true;
          return;
        }

        var apagado = origen.hasAttribute('disabled') || origen.getAttribute('aria-disabled') === 'true';
        boton.disabled = apagado;

        if (apagado) {
          var texto = origen.querySelector('span');
          etiqueta.textContent = (texto ? texto.textContent : origen.textContent).trim();
        } else {
          etiqueta.textContent = barra.dataset.peBarraTexto;
        }

        var p = precioFicha();
        if (p) precio.innerHTML = p.innerHTML;
      }

      boton.addEventListener('click', function () {
        var origen = botonFicha();
        if (origen && !boton.disabled) origen.click();
      });

      copiar();

      // Al cambiar de variante Dawn vuelve a dibujar la columna de la ficha
      // entera, así que se vigila ese trozo y se copia de nuevo.
      var zona = document.querySelector('.product__info-container');
      if (zona && window.MutationObserver) {
        new MutationObserver(copiar).observe(zona, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
        });
      }

      function mostrar(si) {
        barra.classList.toggle('pe-barra--visible', si);
      }

      var referencia = botonFicha();
      if (!referencia) return;

      if (window.IntersectionObserver) {
        new IntersectionObserver(
          function (entradas) {
            entradas.forEach(function (e) {
              // Solo cuando el botón quedó arriba, fuera de pantalla. Si aún
              // no se ha llegado a él, la barra no tiene por qué aparecer.
              mostrar(!e.isIntersecting && e.boundingClientRect.top < 0);
            });
          },
          { threshold: 0 }
        ).observe(referencia);
      } else {
        window.addEventListener(
          'scroll',
          function () {
            var caja = referencia.getBoundingClientRect();
            mostrar(caja.bottom < 0);
          },
          { passive: true }
        );
      }
    }

    function arrancar(ambito) {
      [].slice.call((ambito || document).querySelectorAll('[data-pe-barra]')).forEach(montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        arrancar();
      });
    } else {
      arrancar();
    }

    document.addEventListener('shopify:section:load', function (e) {
      arrancar(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-carrusel"] && !Shopify.designMode) return;
  try {
    
  /* Carrusel flotante: un tiovivo visto de canto.
   *
   * Las tarjetas no van en fila sino repartidas sobre un ovalo. Cada una
   * tiene su angulo; la que esta en 0 queda al frente, crecida y nitida, y
   * las demas se van hacia los lados y hacia el fondo, encogiendo y
   * desenfocandose. Al seguir girando, la que estaba al frente se va por un
   * costado, pasa por detras y vuelve a asomar por el otro.
   *
   * El giro no es constante. Cada producto tiene su turno: la rueda frena,
   * lo deja quieto de frente un momento y vuelve a girar hasta el
   * siguiente. El tramo entre parada y parada usa una curva que arranca y
   * termina en velocidad cero, asi que la velocidad nunca salta.
   *
   * La escala y el desenfoque salen del coseno del angulo, no de la
   * distancia en pantalla: asi el producto crece de verdad mientras se
   * acerca y el efecto es simetrico a los dos lados.
   */
  (function () {
    var QUIETO = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    function montar(raiz) {
      if (QUIETO && QUIETO.matches) return;

      var cinta = raiz.querySelector('.pe-carr__cinta');
      var marco = raiz.querySelector('.pe-carr__marco');
      if (!cinta || !marco) return;
      if (cinta.classList.contains('pe-carr__cinta--quieta')) return;

      // Solo la primera vuelta: la copia existia para cerrar el bucle de la
      // cinta plana, y en un ovalo sobra.
      var tandas = cinta.querySelectorAll('.pe-carr__tanda');
      if (!tandas.length) return;
      var tarjetas = [].slice.call(tandas[0].querySelectorAll('.pe-carr__card'));
      var n = tarjetas.length;
      if (n < 3) return;

      var escenas = tarjetas.map(function (c) {
        return c.querySelector('.pe-carr__escena');
      });
      var precios = tarjetas.map(function (c) {
        return c.querySelector('.pe-carr__precio');
      });
      var angosto = false;
      // Lo ultimo que se le escribio a cada tarjeta. Sirve para no repetir
      // escrituras: cambiar el filtro de desenfoque obliga al navegador a
      // volver a rasterizar esa capa, y hacerlo sesenta veces por segundo
      // en cada tarjeta es lo que de verdad cuesta aqui, mucho mas que el
      // numero de productos.
      var ultimo = tarjetas.map(function () {
        return {};
      });
      // En el movil el zoom es mas corto. 1.55 sobre una pantalla de 375
      // deja la escena en 294px de alto y 264 de ancho: no cabe, y por eso
      // la foto se veia recortada. En el ordenador se queda como estaba.
      var ESCALA_MAX = 1.55;
      var caida = 1.14;
      var radioX = 0;
      var altoCarril = 0;
      var altoEscena = 0;
      var anchoTarjeta = 0;
      var crecida = 0;

      function medir() {
        // Si el marco todavia no tiene ancho —la seccion aun no se ha
        // dibujado, o esta dentro de algo oculto— no se mide nada: con un
        // cero el ovalo saldria mal y se quedaria mal para siempre. Se
        // vuelve a intentar en el cuadro siguiente.
        if (!marco.offsetWidth) {
          medido = false;
          return;
        }
        anchoTarjeta = tarjetas[0].offsetWidth || 230;
        altoEscena = escenas[0] ? escenas[0].offsetHeight : 0;

        angosto = window.innerWidth < 750;
        ESCALA_MAX = angosto ? 1.28 : 1.55;
        // Los de perfil se quedan en 0.98 con cualquier zoom: la caida se
        // calcula desde el maximo para que la proporcion no cambie.
        caida = (ESCALA_MAX - 0.98) * 2;
        // El ovalo se abre casi hasta los bordes del marco. Se descuenta
        // parte de una tarjeta para que la de los extremos no se salga.
        radioX = marco.offsetWidth / 2 - anchoTarjeta * 0.42;
        // Un suelo para las pantallas angostas. Antes el suelo era el ancho
        // entero de una tarjeta y en un telefono forzaba un ovalo mas ancho
        // que la pantalla; que se solapen estando al fondo no molesta.
        if (radioX < anchoTarjeta * 0.62) radioX = anchoTarjeta * 0.62;
        medido = true;
        altoCarril = 0;
        for (var i = 0; i < n; i++) {
          var h = tarjetas[i].offsetHeight;
          if (h > altoCarril) altoCarril = h;
        }
        // El sitio que hace falta arriba no se estima: se calcula. La escena
        // crece hasta ESCALA_MAX tirando desde su base, asi que sobresale
        // exactamente lo que mide por ese tanto de más. Antes iba a ojo y
        // la foto se recortaba al pasar por el frente.
        // Holgura por encima de lo que crece la escena: un 4% en el
        // ordenador por el acercamiento del ratón, y un 12% en el móvil,
        // donde el margen de error es menor y cualquier recorte se nota.
        var holgura = angosto ? 1.12 : 1.04;
        crecida = Math.ceil(altoEscena * (ESCALA_MAX * holgura - 1));
        cinta.style.height = altoCarril + crecida + 'px';
        for (var j = 0; j < n; j++) {
          tarjetas[j].style.top = crecida + 'px';
        }
      }

      var vuelta = parseFloat(raiz.getAttribute('data-pe-vuelta')) || 28;
      var porProducto = (vuelta * 1000) / n;
      var descanso = (parseFloat(raiz.getAttribute('data-pe-descanso')) || 35) / 100;
      var tiempoQuieto = porProducto * descanso;
      var tiempoMovil = porProducto - tiempoQuieto;
      var TAU = Math.PI * 2;
      var salto = TAU / n;

      function suave(u) {
        if (u < 0.5) return 4 * u * u * u;
        var v = -2 * u + 2;
        return 1 - (v * v * v) / 2;
      }

      var medido = false;
      var reloj = 0;
      var previo = null;
      var pausado = false;
      var lazo = null;

      // Lo manual no reemplaza al giro automatico: se suma. Asi la rueda
      // nunca se detiene, y las flechas y el dedo solo la adelantan o la
      // atrasan sobre lo que ya venia haciendo.
      var desvio = 0;      // donde esta ahora el desvio manual
      var destino = 0;     // a donde va
      var arrastrando = false;
      var inercia = 0;     // lo que sigue corriendo despues de soltar

      var listo = false;

      function pintar(ahora) {
        // La animacion de CSS no se apaga hasta que este lazo pinta su
        // primer cuadro. Si el navegador nunca llegara a llamarnos, la
        // cinta seguiria girando como siempre en vez de congelarse.
        if (!listo) {
          raiz.classList.add('pe-carr--js');
          listo = true;
        }
        if (!medido) {
          medir();
          if (!medido) {
            // Sin medida no se puede colocar nada. Se espera al cuadro
            // siguiente en vez de dibujar mal.
            lazo = requestAnimationFrame(pintar);
            return;
          }
        }
        if (previo === null) previo = ahora;
        var d = ahora - previo;
        previo = ahora;
        if (d > 120) d = 120;   // al volver de otra pestana, sin brincos
        if (!pausado) reloj += d;

        var ciclo = reloj % porProducto;
        var enteros = Math.floor(reloj / porProducto);
        var u = ciclo <= tiempoQuieto ? 0 : (ciclo - tiempoQuieto) / tiempoMovil;

        if (inercia) {
          // Despues de un impulso la rueda sigue corriendo y se va
          // frenando sola, como al empujar algo que gira. Es lo que
          // permite recorrer varios productos de un gesto en vez de uno.
          desvio += inercia * d;
          inercia *= Math.pow(0.0016, d / 1000);
          if (Math.abs(inercia) < 0.00004) {
            inercia = 0;
            destino = Math.round(desvio / salto) * salto;
          }
        } else if (!arrastrando && Math.abs(destino - desvio) > 0.0004) {
          // El desvio se acerca a su destino un porcentaje del camino que
          // falta por milisegundo. Escrito con una potencia para que el
          // resultado no dependa de a cuantos cuadros vaya el navegador.
          desvio += (destino - desvio) * (1 - Math.pow(0.004, d / 1000));
        }

        var giro = (enteros + suave(u)) * salto + desvio;

        for (var i = 0; i < n; i++) {
          // Angulo de esta tarjeta. Se resta el giro para que avancen hacia
          // el frente y no al reves.
          var a = i * salto - giro;
          var s = Math.sin(a);
          var c = Math.cos(a);

          // 0 al frente, 1 justo detras.
          var fondo = (1 - c) / 2;

          var x = radioX * s;
          // Las de atras suben un poco: es lo que da la sensacion de que el
          // ovalo esta inclinado y no visto desde el mismo plano.
          var y = -altoCarril * 0.07 * fondo;
          // El del frente manda: 1.55 contra 0.98 de los que van de perfil.
          // La diferencia tiene que ser grande o no se lee como que uno es
          // el protagonista, solo como que estan a distintas distancias.
          var escala = ESCALA_MAX - caida * fondo;
          var desenfoque = 8.5 * Math.pow(fondo, 1.6);
          var opacidad = 1 - 0.78 * fondo;

          var t = tarjetas[i];
          var u = ultimo[i];

          // La posicion si cambia en cada cuadro: es el movimiento.
          t.style.transform =
            'translate3d(calc(-50% + ' + Math.round(x * 10) / 10 + 'px),' +
            Math.round(y * 10) / 10 + 'px,0)';

          var esc2 = Math.round(escala * 1000) / 1000;
          if (esc2 !== u.esc) {
            u.esc = esc2;
            if (escenas[i]) escenas[i].style.transform = 'scale(' + esc2 + ')';
          }

          // El desenfoque se redondea a cuartos de pixel. Nadie distingue
          // 3.14 de 3.25 y asi la capa se rehace muchas menos veces.
          var des2 = desenfoque < 0.15 ? 0 : Math.round(desenfoque * 4) / 4;
          if (des2 !== u.des) {
            u.des = des2;
            t.style.filter = des2 ? 'blur(' + des2 + 'px)' : 'none';
          }

          var op2 = Math.round(opacidad * 100) / 100;
          if (op2 !== u.op) {
            u.op = op2;
            t.style.opacity = op2;
          }

          // La del frente por delante de todas; las de atras, detras.
          var z2 = Math.round((1 - fondo) * 100);
          if (z2 !== u.z) {
            u.z = z2;
            t.style.zIndex = String(z2);
          }

          // Lo que esta al fondo no se pulsa: queda debajo y desenfocado.
          var pe2 = fondo > 0.55 ? 'none' : 'auto';
          if (pe2 !== u.pe) {
            u.pe = pe2;
            t.style.pointerEvents = pe2;
          }

          // En el movil el precio es solo del que va al frente.
          //
          // Con siete productos, el de al lado ya esta en fondo 0.19, asi
          // que el corte en 0.17 deja el precio para uno solo. No se
          // enciende de golpe: se calcula en cada cuadro con una curva
          // suavizada, de modo que entra y sale mientras el producto se
          // acerca y se aleja, no cuando llega.
          if (precios[i]) {
            if (angosto) {
              var u2 = 1 - fondo / 0.17;
              if (u2 < 0) u2 = 0;
              if (u2 > 1) u2 = 1;
              var pr = Math.round(u2 * u2 * (3 - 2 * u2) * 100) / 100;
              if (pr !== u.pr) {
                u.pr = pr;
                precios[i].style.opacity = pr;
              }
            } else if (precios[i].style.opacity) {
              // De vuelta en pantalla ancha se suelta lo escrito, para que
              // mande el CSS y el precio se vea en todas.
              precios[i].style.opacity = '';
            }
          }
        }

        lazo = requestAnimationFrame(pintar);
      }

      lazo = requestAnimationFrame(pintar);

      // Un clic adelanta un producto. No se acumula sin freno: si se
      // pulsa diez veces seguidas, la rueda dara diez pasos, pero uno
      // detras de otro y sin saltos.
      function paso(sentido) {
        inercia = 0;
        destino += salto * sentido;
      }

      [].slice.call(raiz.querySelectorAll('[data-pe-giro]')).forEach(function (b) {
        var sentido = parseInt(b.getAttribute('data-pe-giro'), 10);
        b.addEventListener('click', function () {
          paso(sentido);
        });
      });

      // Con el dedo: se arrastra de lado y la rueda sigue la mano. Al
      // soltar, el desvio se acomoda al producto mas cercano en vez de
      // quedarse a medio camino entre dos.
      var xInicio = 0;
      var desvioInicio = 0;
      var xUltima = 0;
      var tUltima = 0;
      var velocidad = 0;

      // Cuanto gira la rueda por cada pixel que recorre el dedo.
      //
      // Va en negativo porque un giro creciente mueve las tarjetas hacia la
      // izquierda: para que el carrusel siga a la mano —dedo a la derecha,
      // productos a la derecha— hay que girar al reves. Sin el signo el
      // arrastre se sentia al contrario de lo que uno espera.
      //
      // El divisor es menor que el ancho de una tarjeta a proposito: con el
      // ancho entero se hacia pesado recorrer el carrusel con el dedo.
      function porPixel() {
        return -salto / (anchoTarjeta * 0.62);
      }

      marco.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || e.touches.length !== 1) return;
          arrastrando = true;
          inercia = 0;
          velocidad = 0;
          xInicio = e.touches[0].clientX;
          xUltima = xInicio;
          tUltima = Date.now();
          desvioInicio = desvio;
        },
        { passive: true }
      );

      marco.addEventListener(
        'touchmove',
        function (e) {
          if (!arrastrando || !e.touches || e.touches.length !== 1) return;
          var x = e.touches[0].clientX;
          desvio = desvioInicio + (x - xInicio) * porPixel();

          // Velocidad del ultimo tramo, para saber con cuanta fuerza se
          // solto. Se mide en trozos cortos y no desde el principio del
          // gesto: lo que importa es como termina, no como empezo.
          var ahora = Date.now();
          var dt = ahora - tUltima;
          if (dt > 8) {
            velocidad = ((x - xUltima) * porPixel()) / dt;
            xUltima = x;
            tUltima = ahora;
          }
        },
        { passive: true }
      );

      function soltar() {
        if (!arrastrando) return;
        arrastrando = false;
        // Un gesto lento se acomoda al producto mas cercano; uno con
        // impulso sigue corriendo y se frena solo.
        if (Math.abs(velocidad) > 0.0006 && Date.now() - tUltima < 120) {
          inercia = velocidad;
        } else {
          inercia = 0;
          destino = Math.round(desvio / salto) * salto;
        }
        velocidad = 0;
      }

      marco.addEventListener('touchend', soltar, { passive: true });
      marco.addEventListener('touchcancel', soltar, { passive: true });

      if (raiz.classList.contains('pe-carr--pausa')) {
        marco.addEventListener('mouseenter', function () {
          pausado = true;
        });
        marco.addEventListener('mouseleave', function () {
          pausado = false;
        });
      }

      var temporizador = null;
      window.addEventListener('resize', function () {
        clearTimeout(temporizador);
        temporizador = setTimeout(medir, 180);
      });

      // Fuera de la pantalla no hay nada que animar.
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (filas) {
          filas.forEach(function (fila) {
            if (fila.isIntersecting) {
              if (lazo === null) {
                previo = null;
                lazo = requestAnimationFrame(pintar);
              }
            } else if (lazo !== null) {
              cancelAnimationFrame(lazo);
              lazo = null;
            }
          });
        }, { rootMargin: '200px' }).observe(raiz);
      }
    }

    function arrancar(ambito) {
      [].slice.call((ambito || document).querySelectorAll('.pe-carr')).forEach(montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        arrancar();
      });
    } else {
      arrancar();
    }

    document.addEventListener('shopify:section:load', function (e) {
      arrancar(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-catalogo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function montar(raiz) {
      var chips = raiz.querySelectorAll('.pe-cat__chip');
      var grupos = raiz.querySelectorAll('.pe-cat__grupo');
      if (!chips.length) return;

      function elegir(cat) {
        Array.prototype.forEach.call(chips, function (c) {
          var sel = c.getAttribute('data-cat') === cat;
          c.classList.toggle('is-sel', sel);
          c.setAttribute('aria-pressed', String(sel));
        });

        Array.prototype.forEach.call(grupos, function (g) {
          var toca = cat === 'todos' || g.getAttribute('data-cat') === cat;
          if (toca) {
            g.hidden = false;
            // un cuadro de margen para que la transición tenga desde dónde salir
            requestAnimationFrame(function () {
              g.classList.remove('is-apagado');
            });
          } else {
            g.classList.add('is-apagado');
            // se oculta al terminar el desvanecido, no antes
            setTimeout(function () {
              if (g.classList.contains('is-apagado')) g.hidden = true;
            }, 350);
          }
        });
      }

      // ---- la carpeta ----
      //
      // Se cierra de tres maneras: volviendo a tocarla, con Escape, y al
      // elegir una categoría. Lo de cerrar al elegir es lo natural: ya
      // conseguiste lo que ibas a buscar. Clic afuera se descartó porque en
      // el móvil un arrastre para hacer scroll cuenta como clic fuera y la
      // cerraría sin querer.
      var carpeta = raiz.querySelector('[data-pe-carpeta]');
      var boton = carpeta ? carpeta.querySelector('.pe-cat__folder') : null;
      var panel = carpeta ? carpeta.querySelector('.pe-cat__panel') : null;
      var medida = carpeta ? carpeta.querySelector('[data-pe-pista]') : null;
      var activa = carpeta ? carpeta.querySelector('[data-pe-activa]') : null;
      var activaNombre = carpeta ? carpeta.querySelector('[data-pe-activa-nombre]') : null;
      var quitar = carpeta ? carpeta.querySelector('[data-pe-activa-quitar]') : null;

      // Fijada = abierta con un clic, y entonces no se cierra sola al sacar
      // el ratón. Abrir al pasar por encima es cómodo, pero si además se
      // cerrara al alejarse de un clic deliberado sería exasperante.
      var fijada = false;
      var cierreLento = null;

      function abrir(si) {
        if (!carpeta || !boton) return;
        clearTimeout(cierreLento);
        carpeta.classList.toggle('is-abierta', si);
        boton.setAttribute('aria-expanded', String(si));
        if (!si) fijada = false;
        if (!panel || !medida) return;

        // La pista mantiene su propio alto aunque el panel esté a cero y la
        // recorte, así que sirve de regla para saber cuánto tiene que crecer.
        if (si) {
          panel.style.height = medida.offsetHeight + 'px';
        } else {
          // De 'auto' a cero el navegador salta sin animar: hay que fijar
          // antes el alto real y forzar el recálculo.
          panel.style.height = panel.offsetHeight + 'px';
          void panel.offsetHeight;
          panel.style.height = '0px';
        }
      }

      // Al terminar de abrir se suelta el alto, para que el panel siga al
      // contenido si la fila se reajusta al girar el teléfono.
      if (panel) {
        panel.addEventListener('transitionend', function (e) {
          if (e.propertyName !== 'height' || e.target !== panel) return;
          if (carpeta.classList.contains('is-abierta')) panel.style.height = 'auto';
        });
      }

      if (boton) {
        boton.addEventListener('click', function () {
          // Si ya estaba abierta por el ratón, el clic la deja fijada en vez
          // de cerrarla: cerrar algo que el visitante acaba de pedir a
          // propósito se siente roto.
          if (carpeta.classList.contains('is-abierta') && !fijada) {
            fijada = true;
            return;
          }
          var abre = !carpeta.classList.contains('is-abierta');
          abrir(abre);
          fijada = abre;
        });
      }

      // Con el ratón encima se abre sola. El retardo al salir evita que se
      // cierre de golpe al cruzar el hueco entre la carpeta y las
      // categorías.
      //
      // Solo donde hay puntero de verdad: en una pantalla táctil el
      // navegador se inventa un mouseenter al tocar, y la carpeta acabaría
      // abriéndose y cerrándose sola. Ahí manda el toque y nada más.
      var hayPuntero = window.matchMedia
        ? window.matchMedia('(hover: hover)').matches
        : true;

      if (carpeta && hayPuntero) {
        carpeta.addEventListener('mouseenter', function () {
          clearTimeout(cierreLento);
          abrir(true);
        });

        carpeta.addEventListener('mouseleave', function () {
          if (fijada) return;
          clearTimeout(cierreLento);
          cierreLento = setTimeout(function () {
            abrir(false);
          }, 220);
        });
      }

      // Con el tabulador también se abre: quien no usa ratón tiene que poder
      // llegar a las categorías igual.
      if (boton) {
        boton.addEventListener('focus', function () {
          abrir(true);
        });
      }

      // ---- la fila que se desliza ----
      //
      // Doce categorías con nombre largo dan casi el doble del ancho de la
      // página, así que hay que poder recorrerlas. Con dejar el puntero
      // sobre la flecha basta: no hay que hacer clic ni arrastrar.
      var pista = raiz.querySelector('[data-pe-pista]');
      var fila = raiz.querySelector('.pe-cat__filtros');
      var flechas = pista ? pista.querySelectorAll('[data-pe-desliz]') : [];

      if (pista && fila) {
        // Píxeles por cuadro. A 60 cuadros por segundo son unos 100 px/s:
        // se lee mientras pasa, que es de lo que se trata.
        var PASO = 1.7;
        var corriendo = null;

        function marcarBordes() {
          var sobra = fila.scrollWidth - fila.clientWidth;
          var izq = fila.scrollLeft > 2;
          var der = fila.scrollLeft < sobra - 2;
          pista.classList.toggle('hay-izq', izq);
          pista.classList.toggle('hay-der', der);
          Array.prototype.forEach.call(flechas, function (b) {
            var haciaLaDerecha = b.getAttribute('data-pe-desliz') === '1';
            var toca = haciaLaDerecha ? der : izq;
            b.hidden = !toca;
            if (!toca) parar();
          });
        }

        function parar() {
          if (corriendo === null) return;
          cancelAnimationFrame(corriendo);
          corriendo = null;
        }

        function correr(sentido) {
          parar();
          var paso = function () {
            var antes = fila.scrollLeft;
            fila.scrollLeft = antes + PASO * sentido;
            marcarBordes();
            // Si el scroll ya no se mueve es que se llegó al final: seguir
            // pidiendo cuadros ahí no haría más que gastar batería.
            if (fila.scrollLeft === antes) return parar();
            corriendo = requestAnimationFrame(paso);
          };
          corriendo = requestAnimationFrame(paso);
        }

        Array.prototype.forEach.call(flechas, function (b) {
          var sentido = parseInt(b.getAttribute('data-pe-desliz'), 10);
          if (hayPuntero) {
            b.addEventListener('mouseenter', function () {
              correr(sentido);
            });
            b.addEventListener('mouseleave', parar);
          }
          // El clic da un salto de una pantalla, para el móvil y el teclado,
          // donde no existe el "dejar el puntero encima".
          b.addEventListener('click', function () {
            parar();
            fila.scrollBy({ left: fila.clientWidth * 0.8 * sentido, behavior: 'smooth' });
          });
          b.addEventListener('focus', function () {
            correr(sentido);
          });
          b.addEventListener('blur', parar);
        });

        fila.addEventListener('scroll', marcarBordes, { passive: true });
        window.addEventListener('resize', marcarBordes);
        // Al cerrarse la carpeta se para: si no, seguiría corriendo sin que
        // nadie lo vea.
        if (hayPuntero) carpeta.addEventListener('mouseleave', parar);
        marcarBordes();
      }

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!carpeta || !carpeta.classList.contains('is-abierta')) return;
        abrir(false);
        if (boton) boton.focus();
      });

      // Un clic fuera también la cierra. Se escucha 'click' y no
      // 'touchstart' a propósito: al arrastrar para hacer rodar la página
      // el navegador no dispara clic, así que un desplazamiento no la
      // cierra sin querer. Ese era el motivo para haberlo descartado.
      document.addEventListener('click', function (e) {
        if (!carpeta || !carpeta.classList.contains('is-abierta')) return;
        if (carpeta.contains(e.target)) return;
        abrir(false);
      });

      // Deja a la vista qué filtro está puesto aunque la carpeta esté
      // cerrada, para que nadie crea que faltan productos.
      function pintarActiva(cat) {
        if (!activa) return;
        if (cat === 'todos') {
          activa.hidden = true;
          return;
        }
        var chip = raiz.querySelector('.pe-cat__chip[data-cat="' + cat + '"]');
        var nombre = chip ? chip.querySelector('.pe-cat__chip-nombre') : null;
        if (activaNombre) activaNombre.textContent = nombre ? nombre.textContent.trim() : cat;
        activa.hidden = false;
      }

      if (quitar) {
        quitar.addEventListener('click', function () {
          elegir('todos');
          pintarActiva('todos');
        });
      }

      Array.prototype.forEach.call(chips, function (c) {
        c.addEventListener('click', function () {
          var cat = c.getAttribute('data-cat');
          elegir(cat);
          pintarActiva(cat);
          abrir(false);
          var cabeza = carpeta || raiz.querySelector('.pe-cat__filtros');
          if (cabeza) {
            var y = cabeza.getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        });
      });

      // Se puede llegar con la categoría ya elegida: /pages/catalogo#cat-cables.
      // Lo usa la página de error para mandar a una categoría concreta en vez
      // de a la lista genérica de Shopify.
      function desdeLaUrl() {
        var h = window.location.hash;
        if (h.indexOf('#cat-') !== 0) return;
        var cat = h.slice(5);
        var existe = raiz.querySelector('.pe-cat__chip[data-cat="' + cat + '"]');
        if (!existe) return;
        elegir(cat);
        // Se llega con el filtro puesto desde la cabecera o desde el 404, y
        // la carpeta está cerrada: sin esto no se vería qué se está mirando.
        pintarActiva(cat);
      }
      desdeLaUrl();
      window.addEventListener('hashchange', desdeLaUrl);
    }

    // Agregar al carrito desde el catálogo, sin salir de la página.
    //
    // Se replica lo que hace el formulario de producto de Dawn: se piden de
    // paso las secciones del cajón y se le entregan, para que se redibuje con
    // el producto recién agregado en vez de quedarse con lo de antes.
    //
    // Sin JavaScript el formulario no hace nada, por eso el enlace de la
    // tarjeta sigue llevando a la ficha: ahí el botón de comprar es de Dawn
    // y funciona igual.
    function montarAgregar(raiz) {
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-pe-agregar]'), function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('button');
          if (btn.getAttribute('aria-busy') === 'true') return;
          btn.setAttribute('aria-busy', 'true');

          var cajon = document.querySelector('cart-drawer');
          var datos = new FormData(form);
          datos.append('quantity', 1);
          if (cajon && typeof cajon.getSectionsToRender === 'function') {
            datos.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }));
            datos.append('sections_url', window.location.pathname);
          }

          var raizUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          fetch(raizUrl + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: datos
          })
            .then(function (r) { return r.json(); })
            .then(function (r) {
              if (r.status) throw new Error(r.description || r.message);
              btn.classList.add('is-listo');
              setTimeout(function () { btn.classList.remove('is-listo'); }, 1600);
              if (cajon && typeof cajon.renderContents === 'function') cajon.renderContents(r);
              if (typeof publish === 'function') publish('cart-update', { source: 'pe-catalogo' });
            })
            .catch(function () {
              // si algo falla, que al menos pueda comprarlo en la ficha
              window.location.href = form.closest('.pe-cat__card').querySelector('.pe-cat__enlace').href;
            })
            .finally(function () { btn.removeAttribute('aria-busy'); });
        });
      });
    }

    function iniciar() {
      Array.prototype.forEach.call(document.querySelectorAll('.pe-cat'), montarAgregar);
      var raices = document.querySelectorAll('.pe-cat');
      Array.prototype.forEach.call(raices, montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-cierre"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function montar(caja) {
      if (caja.dataset.peListo === '1') return;
      caja.dataset.peListo = '1';

      // sin soporte o sin movimiento: se muestra ya, sin esperar al scroll
      var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (quieto || !('IntersectionObserver' in window)) {
        caja.classList.add('is-dentro');
        return;
      }

      new IntersectionObserver(
        function (entradas, obs) {
          for (var i = 0; i < entradas.length; i++) {
            if (entradas[i].isIntersecting) {
              entradas[i].target.classList.add('is-dentro');
              obs.unobserve(entradas[i].target);
            }
          }
        },
        { threshold: 0.2 }
      ).observe(caja);
    }

    function iniciar() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-pe-revelar]'), montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    // el editor de temas vuelve a inyectar la sección al cambiar un ajuste
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-cifras"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURACION = 1600;
    var RETARDO = 120;

    function formatear(v, dec) {
      var partes = v.toFixed(dec).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return partes.join(',');
    }

    function pintar(el, v) {
      var dec = parseInt(el.getAttribute('data-decimales'), 10) || 0;
      el.textContent =
        (el.getAttribute('data-prefijo') || '') +
        formatear(v, dec) +
        (el.getAttribute('data-sufijo') || '');
    }

    function suavizar(t) {
      return 1 - Math.pow(1 - t, 4);
    }

    function correr(el, retardo, reducido) {
      var hasta = parseFloat(el.getAttribute('data-hasta'));
      if (isNaN(hasta)) return;
      if (reducido) {
        pintar(el, hasta);
        return;
      }

      var listo = false;
      function terminar() {
        if (listo) return;
        listo = true;
        pintar(el, hasta);
      }

      pintar(el, 0);
      var t0 = null;
      function paso(ahora) {
        if (listo) return;
        if (t0 === null) t0 = ahora;
        var t = (ahora - t0 - retardo) / DURACION;
        if (t < 0) {
          requestAnimationFrame(paso);
          return;
        }
        if (t >= 1) {
          terminar();
          return;
        }
        pintar(el, hasta * suavizar(t));
        requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);

      // red de seguridad: si los cuadros no llegan, la cifra igual queda bien
      setTimeout(terminar, retardo + DURACION + 250);
    }

    function activar(banda) {
      if (banda.dataset.peListo === '1') return;
      banda.dataset.peListo = '1';
      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var nums = banda.querySelectorAll('.pe-cifras__num[data-hasta]');
      Array.prototype.forEach.call(nums, function (el, i) {
        correr(el, i * RETARDO, reducido);
      });
    }

    function iniciar() {
      var bandas = document.querySelectorAll('[data-pe-cifras]');
      Array.prototype.forEach.call(bandas, function (banda) {
        if (!('IntersectionObserver' in window)) {
          activar(banda);
          return;
        }
        var obs = new IntersectionObserver(
          function (entradas) {
            entradas.forEach(function (e) {
              if (e.isIntersecting) {
                activar(e.target);
                obs.unobserve(e.target);
              }
            });
          },
          { threshold: 0.3 }
        );
        obs.observe(banda);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    // el editor de temas recarga secciones sin recargar la página
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-destacados"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revelar(raiz) {
      var items = raiz.querySelectorAll('.pe-dest__item');
      if (!items.length) return;

      if (
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        Array.prototype.forEach.call(items, function (i) {
          i.classList.add('is-dentro');
        });
        return;
      }

      var obs = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-dentro');
              obs.unobserve(e.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      Array.prototype.forEach.call(items, function (i) {
        obs.observe(i);
      });
    }

    function iniciar() {
      var secciones = document.querySelectorAll('.pe-dest');
      Array.prototype.forEach.call(secciones, revelar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-header"]) return;
  try {
    
  (function () {
    function montar(head) {
      if (head.dataset.peListo === '1') return;
      head.dataset.peListo = '1';

      var boton = head.querySelector('[data-pe-toggle]');
      var nav = head.querySelector('.pe-head__nav');

      if (boton && nav) {
        boton.addEventListener('click', function () {
          var abierto = nav.classList.toggle('is-abierto');
          boton.setAttribute('aria-expanded', String(abierto));
          // se bloquea el fondo para que no se desplace detrás del panel
          document.body.style.overflow = abierto ? 'hidden' : '';
        });

        // al elegir una opción el panel se cierra solo
        Array.prototype.forEach.call(nav.querySelectorAll('a'), function (a) {
          a.addEventListener('click', function () {
            nav.classList.remove('is-abierto');
            boton.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
          });
        });
      }

      // Desplegables de categorías. El <details> ya se abre al pinchar y con
      // teclado; aquí se añade lo que no trae de serie: abrir al pasar el
      // ratón en escritorio, y cerrarse al pinchar fuera o pulsar Escape.
      var despliegues = head.querySelectorAll('.pe-head__desp');

      function cerrarTodos(salvo) {
        Array.prototype.forEach.call(despliegues, function (d) {
          if (d !== salvo) d.removeAttribute('open');
        });
      }

      // Distancia del enlace al borde de abajo de la cabecera. Se mide en
      // vez de calcularse porque depende del alto del enlace, que cambia con
      // el texto y con la tipografía que acabe cargando.
      function medirCaida() {
        var enBarra = window.matchMedia('(min-width: 1251px)').matches;
        Array.prototype.forEach.call(despliegues, function (d) {
          if (!enBarra) {
            d.style.removeProperty('--pe-desp-alto');
            return;
          }
          var caida = head.getBoundingClientRect().bottom - d.getBoundingClientRect().top;
          d.style.setProperty('--pe-desp-alto', Math.round(caida) + 8 + 'px');
        });
      }

      if (despliegues.length) {
        medirCaida();
        window.addEventListener('resize', medirCaida);
        // las tipografías cambian el alto del enlace al terminar de cargar
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(medirCaida);
      }

      Array.prototype.forEach.call(despliegues, function (d) {
        // el ratón solo manda donde el menú está en una barra, no en burbujas
        var enBarra = window.matchMedia('(min-width: 1251px)');
        var salida;

        d.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'touch') return;
          if (!enBarra.matches) return;
          clearTimeout(salida);
          d.setAttribute('open', '');
          cerrarTodos(d);
        });

        d.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'touch') return;
          if (!enBarra.matches) return;
          // margen para cruzar el hueco entre el enlace y el panel
          salida = setTimeout(function () { d.removeAttribute('open'); }, 180);
        });

        d.addEventListener('toggle', function () {
          if (d.hasAttribute('open')) {
            // la cabecera encoge al despegarse de arriba: se vuelve a medir
            medirCaida();
            cerrarTodos(d);
          }
        });

        // al elegir una categoría se cierra
        Array.prototype.forEach.call(d.querySelectorAll('a'), function (a) {
          a.addEventListener('click', function () { d.removeAttribute('open'); });
        });
      });

      if (despliegues.length) {
        document.addEventListener('click', function (e) {
          if (!head.contains(e.target)) cerrarTodos(null);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') cerrarTodos(null);
        });
      }

      // Abrir el carrito desplegable al pinchar el icono del carrito.
      //
      // Dawn engancha esto a un elemento con id="cart-icon-bubble", que es
      // suyo. Nuestra cabecera es propia y no lo tiene, así que sin esto el
      // icono solo navegaba a /cart y el cajón no se abría nunca.
      //
      // Tampoco se le puede poner ese id al nuestro: Dawn le reemplaza el
      // contenido en cada cambio del carrito y nos borraría el icono.
      //
      // Si el cajón no existe —tipo de carrito en "Notificación"— o el JS no
      // cargó, no se toca nada y el enlace sigue llevando a /cart.
      var carro = head.querySelector('.pe-head__carro');
      if (carro) {
        carro.addEventListener('click', function (e) {
          var cajon = document.querySelector('cart-drawer');
          if (!cajon || typeof cajon.open !== 'function') return;
          e.preventDefault();
          cajon.open(carro);
        });
      }

      // Mantener al día el número del carrito.
      //
      // Dawn refresca su propio #cart-icon-bubble, que no tenemos, así que
      // sin esto el contador se quedaba con el número viejo hasta recargar
      // la página. Se escucha el aviso que Dawn publica al cambiar el
      // carrito; si por lo que sea no trae el total, se pregunta a /cart.js.
      function pintarCuenta(n) {
        var c = head.querySelector('.pe-head__cuenta');
        if (!c) return;
        c.textContent = n;
        if (n > 0) c.removeAttribute('hidden');
        else c.setAttribute('hidden', '');
      }

      if (typeof subscribe === 'function') {
        subscribe('cart-update', function (ev) {
          var d = ev && ev.cartData;
          if (d && typeof d.item_count === 'number') {
            pintarCuenta(d.item_count);
            return;
          }
          var raiz = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          fetch(raiz + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (c) { pintarCuenta(c.item_count); })
            .catch(function () {});
        });
      }

      // sombra al despegarse de arriba
      function alScroll() {
        head.classList.toggle('is-pegada', window.scrollY > 8);
      }
      alScroll();
      window.addEventListener('scroll', alScroll, { passive: true });
    }

    function iniciar() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-pe-head]'), montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Campo de puntos del hero: la grilla se aparta al paso del cursor y
    // detrás queda un halo. Un solo trazado para todos los puntos y un
    // único relleno, que con ~2.000 puntos es la diferencia entre ir fluido
    // y arrastrarse.
    function montar(host) {
      if (host.dataset.peListo === '1') return;
      host.dataset.peListo = '1';

      var canvas = host.querySelector('canvas');
      var halo = host.querySelector('.pe-hero__puntos-halo');
      if (!canvas) return;

      var ctx = canvas.getContext('2d', { alpha: true });
      var TAU = Math.PI * 2;
      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var P = {
        dotRadius: 2.4,
        dotSpacing: window.matchMedia('(max-width: 820px)').matches ? 19 : 15,
        cursorRadius: 500,
        bulgeStrength: 67,
        desde: 'rgba(23,180,232,.70)',
        hasta: 'rgba(91,124,250,.50)'
      };

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var puntos = [];
      var W = 0;
      var H = 0;
      var caja = { left: 0, top: 0 };
      var m = { x: -9999, y: -9999, px: -9999, py: -9999, vel: 0 };
      var enfoque = 0;
      var opacidadHalo = 0;
      var raf = null;

      function construir() {
        var paso = P.dotRadius + P.dotSpacing;
        var cols = Math.floor(W / paso);
        var filas = Math.floor(H / paso);
        var padX = (W % paso) / 2;
        var padY = (H % paso) / 2;
        puntos = new Array(filas * cols);
        var k = 0;
        for (var f = 0; f < filas; f++) {
          for (var c = 0; c < cols; c++) {
            var ax = padX + c * paso + paso / 2;
            var ay = padY + f * paso + paso / 2;
            puntos[k++] = { ax: ax, ay: ay, sx: ax, sy: ay };
          }
        }
      }

      function medir() {
        var r = host.getBoundingClientRect();
        W = r.width;
        H = r.height;
        caja.left = r.left;
        caja.top = r.top;
        canvas.width = W * dpr;
        canvas.height = H * dpr;
        canvas.style.width = W + 'px';
        canvas.style.height = H + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        construir();
      }

      // se refresca al hacer scroll: si no, cursor y puntos se desalinean
      function refrescar() {
        var r = host.getBoundingClientRect();
        caja.left = r.left;
        caja.top = r.top;
      }

      function mover(x, y) {
        m.x = x - caja.left;
        m.y = y - caja.top;
      }

      window.addEventListener(
        'mousemove',
        function (e) {
          mover(e.clientX, e.clientY);
        },
        { passive: true }
      );
      window.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length) mover(e.touches[0].clientX, e.touches[0].clientY);
        },
        { passive: true }
      );

      setInterval(function () {
        var dx = m.px - m.x;
        var dy = m.py - m.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        m.vel += (d - m.vel) * 0.5;
        if (m.vel < 0.001) m.vel = 0;
        m.px = m.x;
        m.py = m.y;
      }, 20);

      function pintar() {
        var objetivo = Math.min(m.vel / 5, 1);
        enfoque += (objetivo - enfoque) * 0.06;
        if (enfoque < 0.001) enfoque = 0;

        opacidadHalo += (enfoque - opacidadHalo) * 0.08;
        if (halo) {
          halo.setAttribute('cx', m.x);
          halo.setAttribute('cy', m.y);
          halo.style.opacity = opacidadHalo;
        }

        ctx.clearRect(0, 0, W, H);
        var g = ctx.createLinearGradient(0, 0, W, H);
        g.addColorStop(0, P.desde);
        g.addColorStop(1, P.hasta);
        ctx.fillStyle = g;

        var cr = P.cursorRadius;
        var crSq = cr * cr;
        var rad = P.dotRadius / 2;

        ctx.beginPath();
        for (var i = 0; i < puntos.length; i++) {
          var p = puntos[i];
          var dx = m.x - p.ax;
          var dy = m.y - p.ay;
          var dSq = dx * dx + dy * dy;

          if (dSq < crSq && enfoque > 0.01) {
            var dist = Math.sqrt(dSq);
            var t = 1 - dist / cr;
            var empuje = t * t * P.bulgeStrength * enfoque;
            var ang = Math.atan2(dy, dx);
            p.sx += (p.ax - Math.cos(ang) * empuje - p.sx) * 0.15;
            p.sy += (p.ay - Math.sin(ang) * empuje - p.sy) * 0.15;
          } else {
            p.sx += (p.ax - p.sx) * 0.1;
            p.sy += (p.ay - p.sy) * 0.1;
          }

          ctx.moveTo(p.sx + rad, p.sy);
          ctx.arc(p.sx, p.sy, rad, 0, TAU);
        }
        ctx.fill();

        raf = requestAnimationFrame(pintar);
      }

      function arrancar() {
        if (raf === null) raf = requestAnimationFrame(pintar);
      }
      function detener() {
        if (raf !== null) {
          cancelAnimationFrame(raf);
          raf = null;
        }
      }

      medir();
      var temporizador;
      window.addEventListener('resize', function () {
        clearTimeout(temporizador);
        temporizador = setTimeout(medir, 100);
      });
      window.addEventListener('scroll', refrescar, { passive: true });

      if (reducido) {
        // sin movimiento: se dibuja una vez y se deja quieta
        pintar();
        detener();
      } else if ('IntersectionObserver' in window) {
        // fuera de pantalla no se dibuja: no tiene sentido gastar batería
        new IntersectionObserver(
          function (ent) {
            if (ent[0].isIntersecting) arrancar();
            else detener();
          },
          { threshold: 0 }
        ).observe(host);
      } else {
        arrancar();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) detener();
        else arrancar();
      });
    }

    function iniciar() {
      var campos = document.querySelectorAll('[data-pe-puntos]');
      Array.prototype.forEach.call(campos, montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-opiniones-ml"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function montar(raiz) {
      if (raiz.dataset.peListo === '1') return;
      raiz.dataset.peListo = '1';

      var mas = raiz.querySelector('[data-pe-oml-mas]');
      if (mas) {
        mas.addEventListener('click', function () {
          raiz.classList.add('pe-oml--todas');
        });
      }

      raiz.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-pe-oml-ver]') : null;
        if (!b || !raiz.contains(b)) return;
        abrir(b.dataset.tipo, b.dataset.url);
      });
    }

    function abrir(tipo, url) {
      var lupa = document.createElement('div');
      lupa.className = 'pe-oml-lupa';
      lupa.setAttribute('role', 'dialog');
      lupa.setAttribute('aria-modal', 'true');

      var medio;
      if (tipo === 'video') {
        medio = document.createElement('video');
        medio.src = url;
        medio.controls = true;
        medio.autoplay = true;
        medio.playsInline = true;
      } else {
        medio = document.createElement('img');
        medio.src = url;
        medio.alt = '';
      }

      var cerrar = document.createElement('button');
      cerrar.type = 'button';
      cerrar.className = 'pe-oml-lupa__cerrar';
      cerrar.setAttribute('aria-label', 'Cerrar');
      cerrar.textContent = '×';

      lupa.appendChild(medio);
      lupa.appendChild(cerrar);
      document.body.appendChild(lupa);
      cerrar.focus();

      function fuera() {
        lupa.remove();
        document.removeEventListener('keydown', tecla);
      }

      function tecla(e) {
        if (e.key === 'Escape') fuera();
      }

      // Cerrar tocando el fondo, que es lo que hace todo el mundo en el
      // teléfono antes de buscar la cruz.
      lupa.addEventListener('click', function (e) {
        if (e.target === lupa || e.target === cerrar) fuera();
      });
      document.addEventListener('keydown', tecla);
    }

    function arrancar(ambito) {
      [].slice.call((ambito || document).querySelectorAll('.pe-oml')).forEach(montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        arrancar();
      });
    } else {
      arrancar();
    }

    document.addEventListener('shopify:section:load', function (e) {
      arrancar(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-resenas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Si en este tiempo Judge.me no ha pintado su caja se deja de esperar:
    // la app no está o su script no cargó, y el enlace sigue escondido.
    var ESPERA_MAX = 15000;
    // Judge.me pinta la cabecera y el aviso de "sin reseñas" casi a la vez,
    // pero no hay garantía de que sea en el mismo instante. Antes de concluir
    // que ya hay reseñas se le da un momento para terminar.
    var ASENTAR = 1200;

    function montar(raiz) {
      if (raiz.dataset.peListo === '1') return;
      raiz.dataset.peListo = '1';

      var caja = raiz.querySelector('[data-pe-resenas-caja]');
      var aviso = raiz.querySelector('[data-pe-resenas-aviso]');
      var abrir = raiz.querySelector('[data-pe-resenas-abrir]');
      if (!caja || !aviso || !abrir) return;

      function botonJudgeme() {
        var b = caja.querySelector('.jm-action-buttons__button');
        if (b) return b;
        // Por si Judge.me cambia el nombre de la clase: el botón por su texto.
        var todos = caja.querySelectorAll('button');
        for (var i = 0; i < todos.length; i++) {
          if (/escrib|write/i.test(todos[i].textContent)) return todos[i];
        }
        return null;
      }

      abrir.addEventListener('click', function () {
        var b = botonJudgeme();
        if (b) b.click();
      });

      if (!raiz.classList.contains('pe-resenas--compacta')) return;

      function completa() {
        raiz.classList.remove('pe-resenas--compacta');
        raiz.classList.add('pe-resenas--completa');
        caja.removeAttribute('aria-hidden');
        aviso.hidden = true;
      }

      var decidido = false;
      function decidir() {
        if (decidido) return;
        decidido = true;
        if (caja.querySelector('.jm-no-reviews-state__text')) {
          aviso.hidden = false;
        } else {
          // Judge.me pinta reseñas aunque el metacampo diga cero: el dato va
          // atrasado. Manda lo que se ve.
          completa();
        }
      }

      var observador = null;
      var reloj = null;

      function revisar() {
        if (!botonJudgeme()) return false;
        if (observador) observador.disconnect();
        clearTimeout(reloj);
        setTimeout(decidir, ASENTAR);
        return true;
      }

      if (revisar()) return;

      observador = new MutationObserver(revisar);
      observador.observe(caja, { childList: true, subtree: true });
      reloj = setTimeout(function () {
        observador.disconnect();
      }, ESPERA_MAX);
    }

    function arrancar(ambito) {
      [].slice.call((ambito || document).querySelectorAll('[data-pe-resenas]')).forEach(montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        arrancar();
      });
    } else {
      arrancar();
    }

    document.addEventListener('shopify:section:load', function (e) {
      arrancar(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-valores"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function montar(raiz) {
      var tarjetas = raiz.querySelectorAll('.pe-val__card');
      var halo = raiz.querySelector('.pe-val__halo');
      if (!tarjetas.length) return;

      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Sin observador o sin movimiento, las tarjetas se muestran ya: nunca
      // se quedan invisibles esperando un evento que no va a llegar.
      if (!('IntersectionObserver' in window) || reducido) {
        Array.prototype.forEach.call(tarjetas, function (t) {
          t.classList.add('is-dentro');
        });
        return;
      }

      var entrada = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-dentro');
            entrada.unobserve(e.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      // El halo toma el color de la tarjeta que domina la pantalla.
      var tono = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting || !halo) return;
            var c = e.target.getAttribute('data-tono');
            if (c) halo.style.setProperty('--halo', c);
          });
        },
        { threshold: 0.55 }
      );

      Array.prototype.forEach.call(tarjetas, function (t) {
        entrada.observe(t);
        tono.observe(t);
      });
    }

    function iniciar() {
      var secciones = document.querySelectorAll('.pe-val');
      Array.prototype.forEach.call(secciones, montar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pe-whatsapp"]) return;
  try {
    
  (function () {
    function limpio(texto) {
      return (texto || '').replace(/\s+/g, ' ').trim();
    }

    function enlace(boton, mensaje) {
      boton.href =
        'https://wa.me/' + boton.getAttribute('data-numero') + '?text=' + encodeURIComponent(mensaje);
    }

    function mensajeProducto(boton) {
      var plantilla = boton.getAttribute('data-plantilla') || '';
      var nombre = boton.getAttribute('data-producto') || '';
      var url = boton.getAttribute('data-enlace') || window.location.href;

      if (boton.getAttribute('data-variante-unica') !== 'true') {
        // Dawn deja la variante elegida en un JSON dentro del selector y lo
        // reemplaza cada vez que el cliente cambia de opción.
        var datos = document.querySelector('variant-selects script[data-selected-variant]');
        var variante = null;
        if (datos) {
          try {
            variante = JSON.parse(datos.textContent);
          } catch (e) {}
        }
        var campo = document.querySelector('.product__info-container form[data-type="add-to-cart-form"] input[name="id"]');
        var id = (campo && campo.value) || (variante && variante.id);
        if (id) url += '?variant=' + id;
        if (variante && variante.title && String(variante.id) === String(id)) {
          nombre += ' (' + variante.title + ')';
        }
      }
      return plantilla.split('{producto}').join(nombre).split('{enlace}').join(url);
    }

    function mensajeCarrito(boton) {
      var filas = document.querySelectorAll('cart-items .cart-item');
      var lineas = [];
      Array.prototype.forEach.call(filas, function (fila) {
        var nombre = fila.querySelector('.cart-item__name');
        if (!nombre) return;
        var cantidad = fila.querySelector('.quantity__input');
        var n = cantidad ? parseInt(cantidad.value, 10) || 1 : 1;
        var opciones = [];
        Array.prototype.forEach.call(fila.querySelectorAll('.cart-item__details dl .product-option'), function (op) {
          var t = limpio(op.textContent);
          if (t) opciones.push(t);
        });
        lineas.push('• ' + n + ' × ' + limpio(nombre.textContent) + (opciones.length ? ' (' + opciones.join(', ') + ')' : ''));
      });
      if (!lineas.length) return boton.getAttribute('data-vacio');
      return (boton.getAttribute('data-plantilla') || '').split('{carrito}').join(lineas.join('\n'));
    }

    function mensajeCatalogo(boton) {
      var chip = document.querySelector('.pe-cat__chip.is-sel');
      var categoria = 'el catálogo';
      if (chip && chip.getAttribute('data-cat') !== 'todos') {
        // El chip trae el nombre corto y el largo; se usa el largo ("Carga y energía").
        var nombre = chip.querySelector('.pe-cat__chip-largo') || chip.querySelector('.pe-cat__chip-nombre') || chip;
        categoria = 'la categoría ' + limpio(nombre.textContent);
      }
      return (boton.getAttribute('data-plantilla') || '').split('{categoria}').join(categoria);
    }

    function actualizar(boton) {
      var tipo = boton.getAttribute('data-tipo');
      var mensaje = boton.getAttribute('data-mensaje');
      try {
        if (tipo === 'producto') mensaje = mensajeProducto(boton);
        else if (tipo === 'carrito') mensaje = mensajeCarrito(boton);
        else if (tipo === 'catalogo') mensaje = mensajeCatalogo(boton);
      } catch (e) {
        // Si algo del DOM cambió de forma, queda el mensaje que armó Liquid.
      }
      enlace(boton, mensaje);
    }

    function iniciar() {
      var boton = document.querySelector('[data-pe-wa]');
      if (!boton || boton.dataset.peListo === '1') return;
      boton.dataset.peListo = '1';

      actualizar(boton);
      ['pointerdown', 'focus', 'mouseenter', 'touchstart'].forEach(function (ev) {
        boton.addEventListener(ev, function () {
          actualizar(boton);
        }, { passive: true });
      });

      // Entrada suave al cargar.
      boton.classList.add('pe-wa--esperando');
      setTimeout(function () {
        boton.classList.remove('pe-wa--esperando');
      }, 600);

      // Durante el scroll se achica y se aparta un poco; al parar, vuelve.
      var quieto = null;
      window.addEventListener('scroll', function () {
        boton.classList.add('pe-wa--moviendo');
        clearTimeout(quieto);
        quieto = setTimeout(function () {
          boton.classList.remove('pe-wa--moviendo');
        }, 260);
      }, { passive: true });

      // En la ficha, la barra fija de compra ocupa el borde inferior del
      // celular: el botón sube lo que mide la barra mientras está a la vista.
      var barra = document.querySelector('.pe-barra');
      if (barra && 'MutationObserver' in window) {
        var alzar = function () {
          var visible = barra.classList.contains('pe-barra--visible');
          boton.style.setProperty('--pe-wa-alza', visible ? barra.offsetHeight + 'px' : '0px');
        };
        new MutationObserver(alzar).observe(barra, { attributes: true, attributeFilter: ['class'] });
        window.addEventListener('resize', alzar);
        alzar();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();
})();
